import cn from 'classnames'
import qs from 'qs'
import React from 'react'
import { useTranslation } from 'react-i18next'
import MainButton from '../../components/common/util/input/MainButton'
import { performLogin } from '../../components/helpers/WaxApi'
import Page from '../../components/page/Page'
import UserComponent from '../../components/user/UserComponent'
import config from '../../config.json'

import { useSharedState } from '../../components/waxplorer/Waxplorer'

const AccountPage = (props) => {
    const [state, , { login }] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    return (
        <Page
            title={config.titles.account}
            description={config.descriptions.account}
            id={'AccountPage'}
            banners={false}
        >
            {!userName ? (
                <div className={'flex flex-wrap justify-center'}>
                    <div
                        className={cn(
                            'text-neutral m-auto text-center w-full text-xl my-20',
                        )}
                    >
                        In order to view your Account on the WAX Blockchain
                        click:
                    </div>
                    <MainButton
                        onClick={() => login()}
                        className={'w-40 m-auto'}
                    >
                        Login
                    </MainButton>
                </div>
            ) : (
                <div className={cn('w-full h-auto mx-auto text-base')}>
                    <UserComponent user={userName} {...props} />
                </div>
            )}
        </Page>
    )
}

AccountPage.getInitialProps = async (ctx) => {
    const paths = ctx.asPath.split('/')

    return qs.parse(paths[paths.length - 1].replace('account?', ''))
}

export default AccountPage
